import queryString from 'query-string';
import getSellerDomain from './getSellerDomain';
import getCheckoutPreviewUrl from './getCheckoutPreviewUrl';
import { isDevelopment, isPreview as isPreviewEnv } from './env';

export default function getCheckoutUrl(
  page = {},
  seller = {},
  { isTesting = false, isPreview = false, isConfirmation } = {},
) {
  if (isDevelopment || isPreviewEnv) {
    return getCheckoutPreviewUrl(page, seller, { isTesting, isPreview });
  }

  const pageUrlId = page.slug || page._id;

  const domain = getSellerDomain(seller);

  let checkoutUrl = `${domain}/${pageUrlId}`;

  if (isConfirmation) {
    checkoutUrl = `${domain}/${pageUrlId}/confirmation/${Math.random()}`;
  }

  return queryString.stringifyUrl({
    url: checkoutUrl,
    query: {
      ...(isTesting && { testing: true }),
      ...(isPreview && { preview: true }),
    },
  });
}
